<template>
  <div class="info">
    <div>
      <div class="panel info info-block mbl italic">
        This tool is no longer in use.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  mounted () {
  },
  methods: {},
};
</script>